import React from 'react';
import { ChefHat, Clock, Truck, Heart } from 'lucide-react';

const features = [
  {
    icon: ChefHat,
    title: 'Fait Maison',
    description: 'Tous nos plats sont préparés sur place avec des ingrédients frais.'
  },
  {
    icon: Clock,
    title: 'Service Rapide',
    description: 'Commandez et recevez votre repas en moins de 30 minutes.'
  },
  {
    icon: Truck,
    title: 'Livraison',
    description: 'Livraison gratuite à partir de 20€ dans un rayon de 5km.'
  },
  {
    icon: Heart,
    title: 'Avec Passion',
    description: 'Depuis 2010, nous cuisinons avec amour pour vous régaler.'
  }
];

const AboutSection = () => {
  return (
    <section id="apropos" className="py-20 lg:py-28 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-amber-600 font-semibold text-sm uppercase tracking-wider mb-3">
            Notre Histoire
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            À propos de nous
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Depuis plus de 10 ans, <strong>Le Paradis</strong> est une institution à Bondy.
            Notre passion pour la cuisine italienne et méditerranéenne nous pousse à vous
            offrir chaque jour des plats savoureux, préparés avec des ingrédients de qualité
            et beaucoup d'amour.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
            >
              <div className="w-14 h-14 bg-amber-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-amber-600 transition-colors duration-300">
                <feature.icon className="w-7 h-7 text-amber-600 group-hover:text-white transition-colors duration-300" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8">
          {[
            { value: '15+', label: 'Années d\'expérience' },
            { value: '50+', label: 'Plats au menu' },
            { value: '10k+', label: 'Clients satisfaits' },
            { value: '4.8', label: 'Note moyenne' }
          ].map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl lg:text-5xl font-bold text-amber-600 mb-2">
                {stat.value}
              </div>
              <div className="text-gray-600 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
